import {Outlet} from "react-router-dom"
import {Top} from "pages/main/top/top"
import {Menu} from "pages/main/menu/Menu"

export const Main = () => {
    return (
        <>
            <Top/>
            <div className="main-wrapper">
                <Menu/>
                <div className="main-container">
                    <Outlet/>
                </div>
            </div>
        </>
    )
}